/**
 * Created by Administrator on 2018/2/24.
 */
class Local {
  static set(key, value) {
    window.localStorage.setItem(key, value);
  }

  static get(key) {
    return localStorage.getItem(key)
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static clear() {
    localStorage.clear();
  }
}
export default Local;



// WEBPACK FOOTER //
// ./src/managers/storage/local.js